export default function TeamHome() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-2xl rounded-xl border bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold">Espace équipe</h1>
        <p className="mt-2 text-sm text-gray-600">
          Cette page sert surtout à valider la protection de route par rôle
          (TEAM). Le contenu fonctionnel pourra être branché ensuite.
        </p>
      </div>
    </div>
  );
}

